//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {fetchUser} from '@/api/user'

export default {
  data () {
    return {
      userInfo: {
        company: {}
      }
    }
  },
  methods: {
    getUserInfo () {
      fetchUser().then(resp => {
        this.userInfo = resp.data
      })
    }
  },
  mounted () {
    this.getUserInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/index.vue